import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DesignRoutingModule } from './design-routing.module';
import { SharedModule } from '../shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgsRevealModule } from 'ngx-scrollreveal';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

import { DesignGridComponent } from './design-grid/design-grid.component';
import { DesignComponent } from './design/design.component';
import { DlaComponent } from './dla/dla.component';
import { TntComponent } from './tnt/tnt.component';
import { Kfp3Component } from './kfp3/kfp3.component';
import { TbsComponent } from './tbs/tbs.component';
import { EComponent } from './e/e.component';
import { NoosaComponent } from './noosa/noosa.component';
import { MattelComponent } from './mattel/mattel.component';
import { FoxComponent } from './fox/fox.component';
import { ToyotaComponent } from './toyota/toyota.component';
import { StxComponent } from './stx/stx.component';
import { LovelyComponent } from './lovely/lovely.component';
import { DiscoverComponent } from './discover/discover.component';

@NgModule({
  declarations: [
    DesignGridComponent,
    DesignComponent,
    DlaComponent,    
    TntComponent, 
    Kfp3Component, 
    TbsComponent, 
    EComponent, 
    NoosaComponent, 
    MattelComponent, 
    FoxComponent, 
    ToyotaComponent, 
    StxComponent, 
    LovelyComponent, 
    DiscoverComponent,
  ],
  imports: [
    CommonModule,
    DesignRoutingModule,
    BrowserAnimationsModule,
    NgsRevealModule,
    ScrollToModule.forRoot(),
    SharedModule
  ]
})

export class DesignModule { }